import { webVitalsLog } from 'components/Debug';
import { isNoticiesPath, isEsadirPath, is3catPath, isElClubPath } from 'utils/pathHelper';
import { useEffect } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import 'styles/globals.scss';
//import 'styles/noticies/globals.scss';
import 'the-new-css-reset/css/reset.css';
import App3cat from './3cat/app3cat';
import App3catinfo from './3catinfo/app3catinfo';
import Appesadir from './esadir/appesadir';
import AppElClub from './clubsuper3/appElClub';
import AppCorporatiu from './corporatiu/appCorporatiu';

function MyApp({ Component, pageProps, router }) {
    if (pageProps?.errorCode) {
        throw Error(pageProps.errorCode);
    }
    if (pageProps?.error) {
        throw Error(pageProps.error.message || 'Internal Server Error');
    }

    // Actualizar className del body en navegación client-side
    useEffect(() => {
        const isNoticies = isNoticiesPath(router.asPath);
        const isEsadir = isEsadirPath(router.asPath);
        const isElClub = isElClubPath(router.asPath);
        const is3cat = is3catPath(router.asPath);

        let bodyClass = 'corporatiu';
        if (isNoticies) bodyClass = 'noticies';
        else if (is3cat) bodyClass = 'trescat';
        else if (isEsadir) bodyClass = 'esadir';
        else if (isElClub) bodyClass = 'clubsuper3';

        document.body.className = bodyClass;
    }, [router.asPath]);

    // Evitem errors al prerender del build de la pipe
    if (
        router.pathname === '/3cat/app3cat' ||
        router.pathname === '/3catinfo/app3catinfo' ||
        router.pathname === '/esadir/appesadir' ||
        router.pathname === '/clubsuper3/appElClub' ||
        router.pathname === '/corporatiu/appCorporatiu'
    ) {
        return null;
    }

    const isNoticies = isNoticiesPath(router.asPath);
    const isEsadir = isEsadirPath(router.asPath);
    const isElClub = isElClubPath(router.asPath);
    const is3cat = is3catPath(router.asPath);
    const normalizedPath = router.asPath.split('?')[0].replace(/\/$/, '');
    const shouldLoadAdkaora = isNoticies && normalizedPath === '/3catinfo/ansufati/';

    let appComponent;
    if (isNoticies) {
        appComponent = <App3catinfo Component={Component} pageProps={pageProps} router={router} />;
    } else if (isEsadir) {
        appComponent = <Appesadir Component={Component} pageProps={pageProps} />;
    } else if (is3cat) {
        appComponent = <App3cat Component={Component} pageProps={pageProps} />;
    } else if (isElClub) {
        appComponent = <AppElClub Component={Component} pageProps={pageProps} />;
    } else {
        appComponent = <AppCorporatiu Component={Component} pageProps={pageProps} />;
    }

    return (
        <>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>
            {shouldLoadAdkaora && (
                <Script
                    src='https://cdn.adkaora.space/3cat/generic/prod/adk-init.js'
                    data-version='v3'
                    strategy='afterInteractive'
                />
            )}
            {appComponent}
        </>
    );
}
export default MyApp;

export function reportWebVitals(metric) {
    webVitalsLog(metric);
}
